import PropTypes from 'prop-types';
import React from 'react';
import { Iterable } from 'immutable';

import MainPage from '../../components/MainPage.react';
import SavedJobsStore, { SavedJob } from '../../stores/SavedJobsStore';
import SavedJobActions from '../../actions/SavedJobActions';

import withFilter from '../../components/hocs/withFilter.react';

import SavedJobDeck from './SavedJobDeck.react';
import SavedJobFilter from '../../components/filters/SavedJobFilter.react';
import SavedJobDetail from './SavedJobDetail.react';
import SavedJobForm from './SavedJobForm.react';

import { SavedJobsFilters, makeSavedJobFilter } from '../../util/Filters';

// Sort jobs by ID ascending
function sortJobs(jobSeq) {
  return jobSeq.sort((a, b) => (a.id - b.id));
}

const SavedJobDetailComponent = ({ savedJob, editMode }) => (
  editMode ?
    <SavedJobForm savedJob={savedJob} /> :
    <SavedJobDetail savedJob={savedJob} />
);

SavedJobDetailComponent.propTypes = {
  savedJob: PropTypes.instanceOf(SavedJob),
  editMode: PropTypes.bool,
};

function fetchState(props) {
  return {
    savedJob: props.params.savedJobId ? SavedJobsStore.get(+props.params.savedJobId) : null,
    editMode: props.params.mode === 'edit',
  };
}

class SavedJobs extends React.Component {
  constructor(props) {
    super(props);

    this.state = fetchState(props);
  }

  componentDidMount() {
    SavedJobActions.getSavedJobsForCurrentOrganization();

    if (this.state.savedJob) {
      SavedJobActions.get(this.state.savedJob.id);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState(fetchState(nextProps));
  }

  componentDidUpdate(prevProps, prevState) {
    const prevSavedJobId = prevState.savedJob ? prevState.savedJob.id : null;
    const currentSavedJobId = this.state.savedJob ? this.state.savedJob.id : null;

    if (currentSavedJobId && currentSavedJobId !== prevSavedJobId) {
      SavedJobActions.get(currentSavedJobId);
    }
  }

  render() {
    return (
      <MainPage>
        <div className='saved-job-page'>
          <div className='saved-job-deck-and-filter'>
            <SavedJobFilter
              filters={this.props.filters}
              updateFilter={this.props.updateFilter}
            />
            <SavedJobDeck
              savedJobs={sortJobs(this.props.filteredObjects)}
              selectedSavedJobId={this.state.savedJob ? this.state.savedJob.id : null}
            />
          </div>
          {
            this.state.savedJob &&
              <SavedJobDetailComponent
                savedJob={this.state.savedJob}
                editMode={this.state.editMode}
              />
          }
        </div>
      </MainPage>);
  }
}

export default withFilter(SavedJobsStore, new SavedJobsFilters(), makeSavedJobFilter)(SavedJobs);

SavedJobs.propTypes = {
  // Ignoring this because params is actually used. Seems to be an eslint bug.
  // eslint-ignore-next-line react/no-unused-prop-types
  params: PropTypes.shape({
    savedJobId: PropTypes.string,
    mode: PropTypes.string,
  }),
  filters: PropTypes.instanceOf(SavedJobsFilters),
  updateFilter: PropTypes.func,
  filteredObjects: PropTypes.instanceOf(Iterable),
};

SavedJobs.contextTypes = {
  router: PropTypes.object,
};
